import { h } from 'vue'
import OrganismAccordion from '~/components/organisms/accordion/accordion.vue'
import OrganismHero from '~/components/organisms/hero/hero.vue'
import UiComponentContainer from '~ui/components/container/container.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'faq' }, () => [
    h(OrganismHero, {
      level: 2,
    }, {
      heading: () => props.global.faqTitle,
    }),
    h(OrganismAccordion, {
      items: props.record.faqItems.map(item => ({
        title: item.title,
        content: item.text,
      })),
    }),
  ])
}

Functional.props = {
  global: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
